import { Box, IconButton, Stack, styled } from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import LinkRoundedIcon from '@mui/icons-material/LinkRounded';
import { EmailIcon, EmailShareButton, FacebookIcon, FacebookShareButton, FacebookShareCount, LinkedinIcon, LinkedinShareButton, PocketIcon, PocketShareButton, RedditIcon, RedditShareButton, RedditShareCount, TwitterIcon, TwitterShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share';
import { useState } from 'react';
import * as gtag from '../../../../lib/google/gtag';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.primary.main,
    // color: 'rgba(0, 0, 0, 0.87)',
    color: '#fff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

export default function ShareBlog({ title, slug }) {
  const [clipboard, setClipboard] = useState("Copy link");
  const handleClipboard = (value) => {
    const el = document.createElement('textarea');
    el.value = value;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);

    setClipboard("Copied");
    gtag.event({
      action: "share",
      method: "link",
      content_type: "blog",
      blog_id: slug,
    });
    setTimeout(() => {
      setClipboard("Copy link");
    }, 1500);
  };

  const handleShare = (blog_id, method) => {
    gtag.event({
      action: "share",
      method: method,
      content_type: "blog",
      blog_id: blog_id,
    });
  }

  return (
    <>
      <Stack
        direction="row"
        // justifyContent="flex-start"
        alignItems="center"
        spacing={1}
        sx={{ mt: { sm: 2, xs: 3 }, ml: { xs: 2.5 }, '& svg': { fill: '#000', }, '& svg:hover': { fill: 'currentColor', } }}
      >

        <LightTooltip disableInteractive title="Share on Twitter">
          <TwitterShareButton url={`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`} title={title} hashtags={['blogs', 'grufity']}>
            <IconButton aria-label="twitter" size="small" onClick={() => handleShare(slug, "Twitter")}>
              <TwitterIcon size={30} round iconFillColor="rgba(0, 0, 0, 0.54)" bgStyle={{ fill: 'transparent' }} />
            </IconButton>
          </TwitterShareButton>
        </LightTooltip>

        <LightTooltip disableInteractive title=" Share on Facebook">
          <FacebookShareButton url={`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`} quote={title}>
            <IconButton aria-label="facebook" size="small" onClick={() => handleShare(slug, "Facebook")}>
              <FacebookIcon size={30} round iconFillColor="rgba(0, 0, 0, 0.54)" bgStyle={{ fill: 'transparent' }} />
            </IconButton>
            {/* <div>
            <FacebookShareCount style={{ position: 'absolute', fontSize: '.78rem' }} url={`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`} />
          </div> */}
          </FacebookShareButton>
        </LightTooltip>

        <LightTooltip disableInteractive title=" Share on Reddit">
          <RedditShareButton url={`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`} windowWidth={660} windowHeight={460} title={title}>
            <IconButton aria-label="reddit" size="small" onClick={() => handleShare(slug, "Reddit")}>
              <RedditIcon size={30} round iconFillColor="rgba(0, 0, 0, 0.54)" bgStyle={{ fill: 'transparent' }} />
            </IconButton>
            {/* <div>
            <RedditShareCount style={{ position: 'absolute', fontSize: '.78rem' }} url={`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`} />
          </div> */}
          </RedditShareButton>
        </LightTooltip>

        <LightTooltip disableInteractive title=" Share on Whatsapp">
          <WhatsappShareButton url={`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`} title={title} separator=":: ">
            <IconButton aria-label="whatsapp" size="small" onClick={() => handleShare(slug, "Whatsapp")}>
              <WhatsappIcon size={24} round iconFillColor="rgba(0, 0, 0, 0.54)" bgStyle={{ fill: 'transparent' }} />
            </IconButton>
          </WhatsappShareButton>
        </LightTooltip>

        <LightTooltip disableInteractive title=" Share on Linkedin">
          <LinkedinShareButton url={`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`}>
            <IconButton aria-label="linkedin" size="small" onClick={() => handleShare(slug, "Linkedin")}>
              <LinkedinIcon size={30} round iconFillColor="rgba(0, 0, 0, 0.54)" bgStyle={{ fill: 'transparent' }} />
            </IconButton>
          </LinkedinShareButton>
        </LightTooltip>

        {/* <PocketShareButton url={`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`} title={title}>
          <LightTooltip disableInteractive title=" Share on Pocket">
            <IconButton aria-label="linkedin" size="small" onClick={()=>handleShare(slug,method="")}>
              <PocketIcon size={30} round iconFillColor="rgba(0, 0, 0, 0.54)" bgStyle={{ fill: 'transparent' }} />
            </IconButton>
          </LightTooltip>
        </PocketShareButton>

        <EmailShareButton url={`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`} title={title} body="body">
          <LightTooltip disableInteractive title=" Share with Email">
            <IconButton aria-label="linkedin" size="small" onClick={()=>handleShare(slug,method="")}>
              <EmailIcon size={32} round iconFillColor="rgba(0, 0, 0, 0.54)" bgStyle={{ fill: 'transparent' }} />
            </IconButton>
          </LightTooltip>
        </EmailShareButton> */}
        <LightTooltip disableInteractive title={clipboard}>
          <Box component="div" sx={{ margin: '13px 8px 5px 22px !important', cursor: 'pointer' }}>
            <LinkRoundedIcon fontSize="small" onClick={() => handleClipboard(`${process.env.NEXT_PUBLIC_URL}/blogs/${slug}`)} />
          </Box>
        </LightTooltip>
      </Stack>
    </>
  )
}
